import '@angular/compiler';
import { PageQuizSettingComponent } from './page.quiz.setting/page.quiz.setting.component';
import { PageRegisterComponent } from './page.register/page.register.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageQuizPlayComponent } from './page.quiz.play/page.quiz.play.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageWrongNoteComponent } from './page.wrong.note/page.wrong.note.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminSubjectsComponent } from './page.admin.subjects/page.admin.subjects.component';
import { PageAdminQuestionsComponent } from './page.admin.questions/page.admin.questions.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageTextbookStudyComponent } from './page.textbook.study/page.textbook.study.component';
import { PageQuizResultComponent } from './page.quiz.result/page.quiz.result.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageTextbookListComponent } from './page.textbook.list/page.textbook.list.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMockExamComponent } from './page.mock.exam/page.mock.exam.component';
import { PageSubjectItemComponent } from './page.subject.item/page.subject.item.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "quiz/setting",
                component: PageQuizSettingComponent,
                "app_id": "page.quiz.setting"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "wrong-note",
                component: PageWrongNoteComponent,
                "app_id": "page.wrong.note"
            },
            {
                "path": "admin/subjects",
                component: PageAdminSubjectsComponent,
                "app_id": "page.admin.subjects"
            },
            {
                "path": "admin/questions",
                component: PageAdminQuestionsComponent,
                "app_id": "page.admin.questions"
            },
            {
                "path": "textbook/:id/:page?",
                component: PageTextbookStudyComponent,
                "app_id": "page.textbook.study"
            },
            {
                "path": "quiz/result/:id",
                component: PageQuizResultComponent,
                "app_id": "page.quiz.result"
            },
            {
                "path": "textbook",
                component: PageTextbookListComponent,
                "app_id": "page.textbook.list"
            },
            {
                "path": "mock-exam",
                component: PageMockExamComponent,
                "app_id": "page.mock.exam"
            },
            {
                "path": "subject/:id",
                component: PageSubjectItemComponent,
                "app_id": "page.subject.item"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "register",
                component: PageRegisterComponent,
                "app_id": "page.register"
            },
            {
                "path": "quiz/play/:id",
                component: PageQuizPlayComponent,
                "app_id": "page.quiz.play"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }